import { deleteDbByName } from './dbStorage'

let isEnabled = true

export function getIsStorageEnabled() {
  return isEnabled
}

export function setIsStorageActive(enable = true) {
  isEnabled = enable
}

export const STORAGE_NAME_PREFIX = 'lnd_actionCardData'

export function getLocalDataByKey(key) {
  const data = localStorage.getItem(getStorageNameByKey(key))
  return data ? JSON.parse(data) : null
}

export function saveLocalDataByKey(data, key) {
  localStorage.setItem(getStorageNameByKey(key), JSON.stringify(data))
}

export function getLocalData(playbookId) {
  return getLocalDataByKey(getActionCardDataKey(playbookId))
}

export function saveLocalData(data, playbookId) {
  saveLocalDataByKey(data, getActionCardDataKey(playbookId))
}

export async function clearLocalData(playbookId) {
  const storageName = getStorageName(playbookId)
  clearLocalDataByName(storageName)
}

export async function clearLocalDataByPrefix(prefix) {
  for (const storageName in localStorage) {
    if (storageName.startsWith(`${STORAGE_NAME_PREFIX}_${prefix}`)) {
      clearLocalDataByName(storageName)
    }
  }
}

async function clearLocalDataByName(storageName) {
  localStorage.removeItem(storageName)
  await deleteDbByName(storageName)
}

export function getActionCardDataKey(playbookId) {
  const searchParams = new URL(location.href).searchParams
  const keys = [...searchParams.keys()].filter(key => key.startsWith('f_'))
  let key = `${playbookId}`
  if (keys.length) key += `_${keys.map(key => `${key.slice(2)}=${searchParams.get(key)}`).join('_')}`
  return key
}

export function getStorageName(playbookId) {
  return getStorageNameByKey(getActionCardDataKey(playbookId))
}

function getStorageNameByKey(key) {
  return `${STORAGE_NAME_PREFIX}_${key}`
}
